<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="isCreate ? newRules: updateRules"
          ref="ruleForm"
          class="flex flex-row w-full"
          autocomplete="off"
        >
          <div class="flex-1 hideHScroll">

            <base-collapsible-form ref="baseCollapsibleConfigGeneral" 
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('distributors.distributor_data')}}</h4>
              </template>
              <template slot="content">
                <div class="lg:mb-2">
                  <div class="mandatory">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.name')}}</label>
                    <el-form-item prop="name">
                      <el-input
                        clearable
                        class="w-full"
                        v-model="form.name"
                        maxlength='250'
                      />
                    </el-form-item>
                  </div>
                </div>

                <div class="lg:mb-2">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('distributors.tipo_distribuidor')}}</label>
                  <el-form-item prop="TipoDistribuidor">
                    <base-el-select class="w-full" :options="tiposDistribuidor" v-model="form.TipoDistribuidor" filterable
                        @change="onChangeTipoDistribuidor" />
                  </el-form-item>
                </div>

                <div class="lg:mb-2">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('distributors.tipo_provisionamiento')}}</label>
                  <el-form-item prop="TipoProvisionamiento">
                    <base-el-select class="w-full" :options="tiposProvisionamiento" v-model="form.TipoProvisionamiento" filterable :disabled="!isCreate" />
                  </el-form-item>
                </div>

              </template>
            </base-collapsible-form>

            <base-collapsible-form ref="baseCollapsibleLicenciamiento" 
              v-if="!isCreate || form.TipoProvisionamiento == 2"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{ $t('license.header_long') }}</h4>
              </template>
              <template slot="content">

              <div class="lg:mb-0" v-if="form.TipoProvisionamiento == 2">
                <div class="flex -mx-2 flex-col lg:flex-row">
                  <div class="px-2 w-full lg:mb-0 mandatory">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('license.num_clients')}}</label>
                    <el-form-item prop="NumClientsTotal">
                      <el-input
                        clearable
                        class="w-full"
                        v-model.number="form.NumClientsTotal"
                        :maxlength="validation.NumClientsTotal"/>
                    </el-form-item>
                  </div>
                  <div class="px-2 w-full lg:mb-0 mandatory">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('license.num_invoices')}}</label>
                    <el-form-item prop="NumInvoicesTotal">
                      <el-input 
                        clearable 
                        class="w-full"
                        v-model.number="form.NumInvoicesTotal" 
                        :maxlength="validation.NumInvoicesTotal" />
                    </el-form-item>
                  </div>
                  <div class="px-2 w-full lg:mb-0 mandatory" v-if="role === 3">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('license.num_volumen_invoices')}}</label>
                    <el-form-item prop="NumVolumenTotal">
                      <el-input 
                        clearable 
                        class="w-full"
                        v-model.number="form.NumVolumenTotal" 
                        :maxlength="validation.NumVolumenTotal" />
                    </el-form-item>
                  </div>
                </div>
              </div>
              
              <div class="lg:mb-0" v-if="form.TipoProvisionamiento == 2">
                <div class="flex -mx-2 flex-col lg:flex-row">
                  <div class="px-2 w-full lg:mb-0 mandatory">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('license.stored_space')}}</label>
                    <el-form-item prop="StoredSpaceTotal">
                      <el-input
                        clearable
                        class="w-full"
                        v-model.number="form.StoredSpaceTotal"
                        :maxlength="validation.StoredSpaceTotal">
                        <template slot="append">MB</template>
                      </el-input>
                    </el-form-item>
                  </div>
                  <div class="px-2 w-full lg:mb-0 mandatory">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('license.num_companies')}}</label>
                    <el-form-item prop="NumCompaniesTotal">
                      <el-input
                        clearable
                        class="w-full"
                        v-model.number="form.NumCompaniesTotal"
                        :maxlength="validation.NumCompaniesTotal"/>
                    </el-form-item>
                  </div>
                  <div class="px-2 w-full lg:mb-0 mandatory">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('license.num_users')}}</label>
                    <el-form-item prop="NumUsersTotal">
                      <el-input
                        clearable
                        class="w-full"
                        v-model.number="form.NumUsersTotal"
                        :maxlength="validation.NumUsersTotal"/>
                    </el-form-item>
                  </div>
                </div>
              </div>

              <div v-if="!isCreate">
                <div class="mb-4">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('license.num_clients')}}</label>
                  <div class="flex flex-row mt-2">
                    <span class="w-48 text-sm text-secondary-600 dark:text-darkblue-200">{{ $n(form.NumClients, 'integer') }} / {{ $n(form.NumClientsTotalProgres, 'integer') }}</span>
                    <el-progress class="w-full dark:text-darkblue-200" :percentage="percentageNumClients" :color="customColorMethod"></el-progress>
                  </div>
                </div>
                <div class="mb-4">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('license.num_invoices')}}</label>
                  <div class="flex flex-row mt-2">
                    <span class="w-48 text-sm text-secondary-600 dark:text-darkblue-200">{{ $n(form.NumInvoices, 'integer') }} / {{ $n(form.NumInvoicesTotalProgres, 'integer') }}</span>
                    <el-progress class="w-full dark:text-darkblue-200" :percentage="percentageNumInvoices" :color="customColorMethod"></el-progress>
                  </div>
                </div>
                <div class="mb-4" v-if="role === 3">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('license.num_volumen_invoices')}}</label>
                  <div class="flex flex-row mt-2">
                    <span class="w-48 text-sm text-secondary-600 dark:text-darkblue-200">{{ $n(form.NumVolumen, 'decimal') }} / {{ $n(form.NumVolumenTotalProgres, 'decimal') }}</span>
                    <el-progress class="w-full dark:text-darkblue-200" :percentage="percentageNumVolumen" :color="customColorMethod"></el-progress>
                  </div>
                </div>
                <div class="mb-4">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('license.stored_space')}}</label>
                  <div class="flex flex-row mt-2">
                    <span class="w-48 text-sm text-secondary-600 dark:text-darkblue-200">{{ $n(form.StoredSpace, 'integer') }} / {{ $n(form.StoredSpaceTotalProgres, 'integer') }}</span>
                    <el-progress class="w-full dark:text-darkblue-200" :percentage="percentageStoredSpace" :color="customColorMethod"></el-progress>
                  </div>
                </div>
                <div class="mb-4">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('license.num_companies')}}</label>
                  <div class="flex flex-row mt-2">
                    <span class="w-48 text-sm text-secondary-600 dark:text-darkblue-200">{{ $n(form.NumCompanies, 'integer') }} / {{ $n(form.NumCompaniesTotalProgres, 'integer') }}</span>
                    <el-progress class="w-full dark:text-darkblue-200" :percentage="percentageNumCompanies" :color="customColorMethod"></el-progress>
                  </div>
                </div>
                <div class="mb-4">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('license.num_users')}}</label>
                  <div class="flex flex-row mt-2">
                    <span class="w-48 text-sm text-secondary-600 dark:text-darkblue-200">{{ $n(form.NumUsers, 'integer') }} / {{ $n(form.NumUsersTotalProgres, 'integer') }}</span>
                    <el-progress class="w-full dark:text-darkblue-200" :percentage="percentageNumUsers" :color="customColorMethod"></el-progress>
                  </div>
                </div>
              </div>

              </template>
            </base-collapsible-form>
          
            <div v-if="isCreate">
              <base-collapsible-form ref="baseCollapsibleConfigUserInitial" 
                class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                <template slot="headerRight">
                  <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('distributors.initial_dist_user')}}</h4>
                </template>
                <template slot="content">
                  <div class="lg:mb-2">
                    <div class="mandatory">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('users.entity_name')}}</label>
                      <el-form-item prop="username">
                        <el-input
                          :disabled="!isCreate"
                          clearable
                          class="w-full"
                          v-model="form.username"
                          maxlength='50'
                        />
                      </el-form-item>
                    </div>
                  </div>
                  <div class="lg:mb-2">
                    <div class="mandatory">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$tc('users.email', 1)}}</label>
                      <el-form-item prop="email">
                        <el-input
                          :disabled="!isCreate"
                          clearable
                          class="w-full"
                          v-model="form.email"
                          maxlength='255'
                        />
                      </el-form-item>
                    </div>
                  </div>
                  <div class="lg:mb-2">
                    <div class="mandatory">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$tc('app.role', 1)}}</label>
                      <el-form-item prop="roleId">
                        <base-el-select class="w-full" :options="roles" v-model="form.roleId" clearable />
                      </el-form-item>
                    </div>
                  </div>
                  <div class="lg:mb-2">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('app.language') }}</label>
                    <el-form-item prop="idioma">
                      <base-el-select class="w-full" :options="tiposIdioma" v-model="form.idioma" />
                    </el-form-item>
                  </div>
                  
                  <div class="lg:mb-4">
                    <div class="lg:mb-2">
                      <base-password-form-item v-model="form.password" />
                      <base-password-form-item v-model="form.repeat_password" :password="form.password" repeat />
                    </div>
                  </div>
                </template>
              </base-collapsible-form>
            </div>
          </div>

        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive
            mode="secondary"
            :text="isCreate ? $t('app.cancel') : $t('app.back')"
            icon="cross"
            @click="goBack"
            :loading="isGeneralLoading"
          />
          <base-button-responsive
            v-if="!isCreate"
            mode="primary"
            :text="$t('app.goto_clients')"
            icon="company"
            @click="goToClients"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
          <base-button-responsive
            mode="primary"
            :text="$t('app.save')"
            icon="check"
            @click="submitForm('ruleForm')"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
    </template>
  </detail-layout>
</template>

<script>
import { bus } from '@/main'
import { i18n } from '@/i18n'
import DetailLayout from '@/components/layout/DetailLayout.vue'
import { newDistributor } from '@/services/distributors/newDistributor'
import { getDistributor } from '@/services/distributors/getDistributor'
import { updateDistributor } from '@/services/distributors/updateDistributor'
import { email as emailRegex } from '@/utils/regex'

function isValidNumber (value, maxlength) {
  if (Number.isInteger(parseFloat(value))) {
    const max = maxlength > 0 ? Number('9'.repeat(maxlength)) : 0
    if (value >= 0 && value <= max) {
      return true
    }
  }
  return false
}

export default {
  /* eslint-disable camelcase */
  name: 'distributor-detail',
  components: {
    DetailLayout,
  },
  data: function () {
    return {
      showGeneratePassword: false,
      searchView: false,
      activeName: 'es',
      header: {
        title: i18n.t('distributors.header_long'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'configurationssa'
      },
      form: this.getDefaultForm(),
      validation: {
        NumClientsTotal: 4,
        NumInvoicesTotal: 9,
        NumVolumenTotal: 12,
        StoredSpaceTotal: 7,
        NumCompaniesTotal: 4,
        NumUsersTotal: 4,
      },
      updateRules: {
        name: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        TipoDistribuidor: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
        TipoProvisionamiento: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
        NumClientsTotal: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: true, validator: this.isNumberValid, trigger: 'blur' }
        ],
        StoredSpaceTotal: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: true, validator: this.isNumberConnectionsValid, trigger: 'blur' }
        ],
        NumInvoicesTotal: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        NumVolumenTotal: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        NumCompaniesTotal: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: true, validator: this.isNumberValid, trigger: 'blur' }
        ],
        NumUsersTotal: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: true, validator: this.isNumberValid, trigger: 'blur' }
        ],
      },
      newRules: {
        name: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        username: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        email: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { validator: this.isEmailValid, trigger: 'blur' }
        ],
        roleId: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
        tipoAuth: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
        idioma: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          }
        ],
        password: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { validator: this.isPasswordValid, trigger: 'blur' }, // Mixin
          { validator: this.isPasswordValid, trigger: 'change' } // Mixin
        ],
        repeat_password: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { validator: this.isRepeatPasswordValid, trigger: 'blur' }, // Mixin
          { validator: this.isRepeatPasswordValid, trigger: 'change' } // Mixin
        ],
        NumClientsTotal: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: true, validator: this.isNumberValid, trigger: 'blur' }
        ],
        StoredSpaceTotal: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: true, validator: this.isNumberValid, trigger: 'blur' }
        ],
        NumInvoicesTotal: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        NumVolumenTotal: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        NumCompaniesTotal: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: true, validator: this.isNumberValid, trigger: 'blur' }
        ],
        NumUsersTotal: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: true, validator: this.isNumberValid, trigger: 'blur' }
        ],
      }
    }
  },
  computed: {
    percentageNumClients: function () {
      if (this.form.NumClients === 0 || this.form.NumClientsTotalProgres === 0) return 0
      return Math.round((parseInt(this.form.NumClients) * 100) / parseInt(this.form.NumClientsTotalProgres)) 
    },
    percentageNumInvoices: function () {
      if (this.form.NumInvoices === 0 || this.form.NumInvoicesTotalProgres === 0) return 0
      return Math.round((parseInt(this.form.NumInvoices) * 100) / parseInt(this.form.NumInvoicesTotalProgres)) 
    },
    percentageNumVolumen: function () {
      if (this.form.NumVolumen === 0 || this.form.NumVolumenTotalProgres === 0) return 0
      return Math.round((parseInt(this.form.NumVolumen) * 100) / parseInt(this.form.NumVolumenTotalProgres)) 
    },
    percentageStoredSpace: function () {
      if (this.form.StoredSpace === 0 || this.form.StoredSpaceTotalProgres === 0) return 0
      return Math.round((parseInt(this.form.StoredSpace) * 100) / parseInt(this.form.StoredSpaceTotalProgres)) 
    },
    percentageNumCompanies: function () {
      if (this.form.NumCompanies === 0 || this.form.NumCompaniesTotalProgres === 0) return 0
      return Math.round((parseInt(this.form.NumCompanies) * 100) / parseInt(this.form.NumCompaniesTotalProgres)) 
    },
    percentageNumUsers: function () {
      if (this.form.NumUsers === 0 || this.form.NumUsersTotalProgres === 0) return 0
      return Math.round((parseInt(this.form.NumUsers) * 100) / parseInt(this.form.NumUsersTotalProgres)) 
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    id: function () {
      return this.$route.params.id
    },
    isCreate: function () {
      return this.id === -1 || this.id === '-1'
    },
    roles: function () {
      var roles = this.$store.getters['config/ROLES']
      if (this.form.TipoDistribuidor === 1) roles = roles.filter(r => r.id === 7)
      else roles = roles.filter(r => r.id === 7 || r.id === 8)
      return roles
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    calcTotalPGNCIF () {
      if (!this.form.NumLocations || !this.form.NumCompanies) return 0
      return parseInt(this.form.NumLocations) * parseInt(this.form.NumCompanies)
    },
    hasAADIntegration: function () {
      return !!this.$store.getters['auth/hasModuleIntegracionAAD']
    },
    hasSAML2Integration: function () {
      return !!this.$store.getters['auth/hasModuleSAML2']
    },
    tiposAuthFiltered: function () {
      var arrayAuthTypes = this.$store.getters['config/TIPOS_AUTH']
      if (!this.hasAADIntegration) {
        arrayAuthTypes = arrayAuthTypes.filter(x => !['AAD', 'Mixto'].includes(x.key))
      }
      if (!this.hasSAML2Integration) {
        arrayAuthTypes = arrayAuthTypes.filter(x => !['SAML2', 'MixtoSAML2'].includes(x.key))
      }
      return arrayAuthTypes
    },
    tiposDistribuidor: function () {
      return this.$store.getters['config/TIPOS_DISTRIBUIDOR']
    },
    tiposProvisionamiento: function () {
      return this.$store.getters['config/TIPOS_DISTRIBUIDOR_PROVISIONAMIENTO']
    },
    tiposIdioma: function () {
      return this.$store.getters['config/TIPOS_IDIOMA']
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    }
  },
  created: async function () {
    const breadcrumbs = []
    breadcrumbs.push({
      path: 'configurationssa',
      name: i18n.t('configurations.header')
    })

    this.disableRoutes()
    if (!this.isCreate) {
      await this.downloadData(this.id)
      breadcrumbs.push({
        path: 'configurations/distributors',
        name: i18n.t('distributors.header')
      })
      breadcrumbs.push({ path: '', name: this.form.name })
      this.$store.commit('app/setheaderBreadCrumb', this.form.name)
    } else {
      breadcrumbs.push({
        path: '',
        name: i18n.t('distributors.new')
      })
    }
    this.header.breadcrumb = breadcrumbs
  },
  mounted () {
    this.$refs.baseCollapsibleConfigGeneral.toggle()
    if (this.isCreate) {
      this.form.idioma = 'es'
      this.$refs.baseCollapsibleConfigUserInitial.toggle()
    }
  },
  methods: {
    disableRoutes: function () {
      const objDisableRoutes = {
        disableModules: this.form.TipoProvisionamiento === 1,
        disableLocations: this.form.TipoProvisionamiento === 1,
      }
      bus.$emit('disableOptionsDistributor', objDisableRoutes)
    },
    customColorMethod: function (percentage) {
      const normal = 'var(--primary-400)'
      if (this.form.TipoProvisionamiento === 1) {
        return normal
      }
      if (percentage >= 80) {
        return '#ff7c75'
      } else if (percentage >= 60) {
        return '#ffda9e'
      } else {
        return normal
      }
    },
    onChangeTipoDistribuidor () {
      this.form.roleId = null
    },
    goToClients () {
      const filters = {}
      filters.distribuidor = { label: 'Distribuidor', value: { idDistribuidor: this.form.idDistribuidor, Nombre: this.form.name } }
      this.$store.commit('clients/setMasterFilters', filters)
      this.$router.push({ name: 'configurations/clients' })
    },
    isNumberValid: function (rule, value, callback) {
      if (value === undefined || value === null || value === '') {
        return callback(new Error(i18n.t('validation.complete')))
      } else if (value < 0) {
        callback(new Error(i18n.t('validation.num_positive')))
      } else if (!isValidNumber(value, this.validation[rule.field])) {
        callback(new Error(i18n.t('validation.num_max_custom', { max: this.validation[rule.field] })))
      } else {
        callback()
      }
    },
    getDefaultForm: function () {
      return {
        idDistribuidor: '', 
        name: '',
        TipoDistribuidor: 1,
        TipoProvisionamiento: 1,
        username: '',
        email: '',
        roleId: '',
        idioma: '',
        password: '',
        repeat_password: '',
        tipoAuth: 0,

        NumClients: 2,
        StoredSpace: 1000,
        NumInvoices: 10000,
        NumVolumen: 1000000,
        NumCompanies: 20,
        NumUsers: 40,

        NumClientsTotal: 2,
        StoredSpaceTotal: 1000,
        NumInvoicesTotal: 10000,
        NumVolumenTotal: 1000000,
        NumCompaniesTotal: 20,
        NumUsersTotal: 40,

        NumClientsTotalProgres: 0,
        StoredSpaceTotalProgres: 0,
        NumInvoicesTotalProgres: 0,
        NumVolumenTotalProgres: 0,
        NumCompaniesTotalProgres: 0,
        NumUsersTotalProgres: 0,
      }
    },
    watchFormHandler: function ({
      certificate,
      send_alerts
    }) {},
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    isEmailValid: function (rule, value, callback) {
      if (!value) {
        return callback(new Error(i18n.t('validation.complete')))
      }
      if (!emailRegex.test(value)) {
        callback(new Error(i18n.t('validation.email')))
      } else {
        callback()
      }
    },
    submitForm: function (formName) {
      if (this.isCreate) {
        this.newDistributorHandler(formName)
      } else {
        this.updateDistributorHandler(formName)
      }
    },
    newDistributorHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const payload = {
            Nombre: this.form.name,
            primerUsuario: {
              Nombre: this.form.username,
              Email: this.form.email,
              idRol: this.form.roleId,
              Idioma: this.form.idioma,
              Password: this.form.password,
              idTipoAutenticacion: this.form.tipoAuth,
            },
            NumeroCIFEmpresas: this.form.NumCompaniesTotal,
            NumeroUsuarios: this.form.NumUsersTotal,
            NumeroClientes: this.form.NumClientsTotal,
            EspacioTotal: this.form.StoredSpaceTotal,
            NumeroFacturas: this.form.NumInvoicesTotal,
            NumeroVolumen: this.form.NumVolumenTotal,
            idTipoDistribuidor: this.form.TipoDistribuidor,
            idTipoProvisionamiento: this.form.TipoProvisionamiento,
          }
          if (!this.hasAADIntegration && !this.hasSAML2Integration) {
            payload.primerUsuario.idTipoAutenticacion = this.tiposAuthFiltered.find(x => x.key === 'Local')?.value ?? 0
          }
          const response = await newDistributor(payload)
          if (response.blnError === true) {
            this.doFeedback(`${response.msgError} [${response.codError}]`)
          } else {
            this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
            this.resetForm()
            this.form = this.getDefaultForm()
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    updateDistributorHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const payload = {
            Nombre: this.form.name,
            NumeroCIFEmpresas: this.form.NumCompaniesTotal,
            NumeroUsuarios: this.form.NumUsersTotal,
            NumeroClientes: this.form.NumClientsTotal,
            EspacioTotal: this.form.StoredSpaceTotal,
            NumeroFacturas: this.form.NumInvoicesTotal,
            NumeroVolumen: this.form.NumVolumenTotal,
            idTipoDistribuidor: this.form.TipoDistribuidor,
            idTipoProvisionamiento: this.form.TipoProvisionamiento,
          }
          const response = await updateDistributor({ idDistribuidor: this.$route.params.id }, payload)
          if (response.blnError === true) {
            this.doFeedback(`${response.msgError} [${response.codError}]`)
          } else {
            this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
            this.updateView()
            this.$store.commit('app/setheaderBreadCrumb', this.form.name)
            await this.downloadData(this.id)
          }
        } else {
          this.$message({
            type: 'error',
            message: i18n.t('feedback.error.process_data_error')
          })
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    resetForm () {
      this.$refs.ruleForm.resetFields()
    },
    goBack: function () {
      this.$router.push({ name: 'configurations/distributors' })
    },
    downloadData: async function (id) {
      let distributor = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idDistribuidor: id
        }
        distributor = await getDistributor(params)
        this.setDistributor(distributor.distribuidor)
        // Datos Almacenamiento
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return distributor
    },
    setDistributor: function (client) {
      this.form.idDistribuidor = client.IdDistribuidor ? client.IdDistribuidor : null

      this.form.name = client.Nombre

      this.form.NumCompanies = client.NumeroCIFEmpresas ? client.NumeroCIFEmpresas : 0
      this.form.NumUsers = client.NumeroUsuarios ? client.NumeroUsuarios : 0
      this.form.NumClients = client.NumeroClientes ? client.NumeroClientes : 0
      this.form.StoredSpace = client.Espacio ? client.Espacio : 0
      this.form.NumInvoices = client.NumeroFacturas ? client.NumeroFacturas : 0
      this.form.NumVolumen = client.NumeroVolumen ? client.NumeroVolumen : 0

      this.form.NumCompaniesTotal = client.NumeroCIFEmpresasTotal ? client.NumeroCIFEmpresasTotal : 0
      this.form.NumUsersTotal = client.NumeroUsuariosTotal ? client.NumeroUsuariosTotal : 0
      this.form.NumClientsTotal = client.NumeroClientesTotal ? client.NumeroClientesTotal : 0
      this.form.StoredSpaceTotal = client.EspacioTotal ? client.EspacioTotal : 0
      this.form.NumInvoicesTotal = client.NumeroFacturasTotal ? client.NumeroFacturasTotal : 0
      this.form.NumVolumenTotal = client.NumeroVolumenTotal ? client.NumeroVolumenTotal : 0

      this.form.NumCompaniesTotalProgres = client.NumeroCIFEmpresasTotal ? client.NumeroCIFEmpresasTotal : 0
      this.form.NumUsersTotalProgres = client.NumeroUsuariosTotal ? client.NumeroUsuariosTotal : 0
      this.form.NumClientsTotalProgres = client.NumeroClientesTotal ? client.NumeroClientesTotal : 0
      this.form.StoredSpaceTotalProgres = client.EspacioTotal ? client.EspacioTotal : 0
      this.form.NumInvoicesTotalProgres = client.NumeroFacturasTotal ? client.NumeroFacturasTotal : 0
      this.form.NumVolumenTotalProgres = client.NumeroVolumenTotal ? client.NumeroVolumenTotal : 0

      this.form.TipoDistribuidor = client.idTipoDistribuidor ? client.idTipoDistribuidor : null
      this.form.TipoProvisionamiento = client.idTipoProvisionamiento ? client.idTipoProvisionamiento : null

      this.disableRoutes()
    },
    updateView: function () {
      this.header.breadcrumb[2].name = this.form.name
    }
  }
}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
  max-height: 100%;
}
.hideHScroll {
  overflow-x: hidden;
}
</style>
